<h1 class="page-title">
  <a routerLink="./.." class="nav-back"><i class="icon icon-arrow-left-9"></i></a> Research Portal
</h1>
<div class="container">
  <div class="card text-center">
    <p>Sign up for CAL Securities to gain access to a wealth of <br />Market Statistics and Research data.</p>
    <div class="action-btns text-center">
      <a class="more-btn btn btn-fill btn-lg" routerLink="/products/equity">Signup For Equity</a>
    </div>
  </div>
</div>
